import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import task from './modules/task'
import dayanTask from './modules/dayanTask'
import user from './modules/user'
import home from './modules/home'
import node from './modules/node'
import admin from './modules/admin'
import deploy from './modules/deploy'
import statistics from './modules/statistics'
import storage from './modules/storage'
import finance from './modules/finance'
import monitor from './modules/monitor'
import pack from './modules/pack'
import transmission from './modules/transmission'
import exportdata from './modules/exportdata'
import dataGraph from './modules/data-graph'
import ticket from './modules/ticket'
import outsourcing from './modules/outsourcing'
import pagination from './modules/pagination'
import feedback from './modules/feedback'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeModule: '/',
  },
  modules: {
    auth,
    task,
    dayanTask,
    user,
    home,
    node,
    admin,
    deploy,
    statistics,
    storage,
    finance,
    monitor,
    pack,
    transmission,
    exportdata,
    dataGraph,
    ticket,
    outsourcing,
    pagination,
    feedback,
  },
  mutations: {
    set_Module(state, module) {
      // 变更状态
      state.activeModule = module
    },
  },
})
